import GraphcardCommon from './containers/graphcardCommon'

export {default as GraphcardCommonLayout} from './components/graphcardCommonLayout'

export default GraphcardCommon
